import { Component, OnInit, Inject } from '@angular/core';
import { FormGroup, Validators, FormBuilder, FormArray } from '@angular/forms';

import { MAT_DIALOG_DATA } from '@angular/material/dialog';

import { SelectedCrp, Crp } from 'modules/handshakes/handshakes.models';

import { DialogService } from 'modules/shared/components/dialog/dialog.service';

@Component({
  selector: 'artemis-update-existing-crp-dialog',
  templateUrl: './update-existing-crp-dialog.component.html',
  styleUrls: ['./update-existing-crp-dialog.component.scss']
})
export class UpdateExistingCrpDialogComponent implements OnInit {

  crpForm: FormGroup;
  roleForm: FormArray;
  nationalityForm: FormArray;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: { old: Crp, new: SelectedCrp, index: number },
    private dialogService: DialogService,
    private formBuilder: FormBuilder,
  ) { }

  ngOnInit() {
    this.roleForm = this.formBuilder.array([]);
    this.crpForm = this.formBuilder.group({
      name: [, Validators.required],
      idNumber: [],
      address: [],
      nationality: [],
      roles: this.roleForm
    });
    this.patch();
  }

  getRolesFormArray(): FormArray {
    return this.crpForm.get('roles') as FormArray;
  }

  patch() {
    this.crpForm.patchValue(this.data.new);
    const control = <FormArray>this.crpForm.get('roles');
    this.data.new.roles.forEach(x => control.push(this.patchRoles(x)));
  }

  patchRoles(x: any) {
    return this.formBuilder.group({
      id: [x.id],
      role: [x.role],
      dateAppointed: [x.dateAppointed],
      isCheck: [true],
      isDateCheck: [true]
    });
  }

  submit() {
    this.dialogService.getDialogRef().submit({ data: this.crpForm.value, index: this.data.index });
  }

}
